import React from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import {
    Grid,
    Button,
    TableCell,
    TableRow,
    TableContainer,
    Paper,
    Fab,
    Table,
    TableHead,
    TableBody,
    Card,
    CardHeader,
    CardContent,
    CircularProgress,
    TablePagination
} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { getClients, deleteClient, getReportingCurrency, getClientById, getRoles } from "../api/apiClients"
import CreateOrUpdateClient from "./CreateOrUpdateClient";
import ConfirmationDialog from "common/components/ConfirmationDialog";
import CreateOrUpdateUser from "../../users/components/CreateOrUpdateUser";

class Clients extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            clients: [],
            reportingCurrency: [],
            isOpen: false,
            clientToEdit: null,
            clientToDelete: null,
            dialogOpen: false,
            isLoading: true,
            activePage: 0,
            totalElements: 0,
            rowsPerPage: 25,
            userModalOpen: false,
            roles: [],
            clientId: null
        };
    }

    async componentDidMount() {
        this.getClients()
        this.getReportingCurrency()
        this.getRoles()
    }

    handleChangePage = (event, newPage) => {
        this.setState({ activePage: newPage }, () => this.getClients(newPage))
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: event.target.value, activePage: 0 }, () => this.getClients(this.state.activePage))
    };

    getReportingCurrency = () => {
        getReportingCurrency().then((response) => {
            this.setState({ reportingCurrency: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getRoles = () => {
        getRoles().then((response) => {
            this.setState({ roles: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getClients = (page) => {
        getClients({ params: { page: page, size: this.state.rowsPerPage } }).then((response) => {
            this.setState({
                clients: response.data.data.content,
                totalElements: response.data.data.totalElements,
                isLoading: false
            });
            if (page > 0 && response.data.data.content.length === 0) {
                this.setState({ activePage: page }, () => this.getClients(page - 1));
            }
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getClientById = (clientId) => {
        getClientById(clientId).then(response => {
            let clientObject = {
                ...response.data.data,
                imageBase64: "data:image/png;base64," + response.data.data.imageBase64
            }
            this.setState({ clientToEdit: clientObject, initialClient: JSON.parse(JSON.stringify(clientObject)), isOpen: true });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_client_by_id"), { variant: 'error' });
        });
    }

    closeDialog = () => {
        this.setState({ isOpen: false, clientToEdit: null });
    }

    closeDialogUserModal = () => {
        this.setState({ userModalOpen: false });
    }

    deleteClient = () => {
        let { clientToDelete } = this.state
        deleteClient(clientToDelete.id).then(response => {
            this.props.enqueueSnackbar(this.props.t("delete_message", { clientName: this.state.clientToDelete.name }), { variant: 'success' });
            this.setState({ dialogOpen: false, clientToDelete: null, rowsPerPage: this.state.rowsPerPage }, () => this.getClients(0));
        }).catch(error => {
            console.log(error)
            this.props.enqueueSnackbar(this.props.t("error_delete_client"), { variant: 'error' });
        });
    }

    render() {

        let { clients, isOpen, dialogOpen, clientToDelete, isLoading, userModalOpen, clientId } = this.state;

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        let clientsList;
        let recordsNotFound;
        if (clients && clients.length > 0) {
            clientsList = clients.map((client, index) => {
                return <TableRow key={index}>
                    <TableCell><Fab title={this.props.t("users_list")} onClick={() => this.props.history.push({
                        pathname: '/users/',
                        state: {
                            selectedClient: client,
                        },
                    })} size="small" style={{ marginRight: 10 }} color="default" aria-label="search">
                        <SearchIcon />
                    </Fab></TableCell>
                    <TableCell>{client.name}</TableCell>
                    <TableCell>{client.address}</TableCell>
                    <TableCell>{client.city}</TableCell>
                    <TableCell>{client.postalCode}</TableCell>
                    <TableCell>{client.country}</TableCell>
                    <TableCell>{client.reportingCurrency}</TableCell>
                    <TableCell>{client.isActive ? <CheckIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'green' }} /> : <CloseIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'red' }} />}</TableCell>
                    <TableCell>
                        <Fab title={this.props.t("edit")} onClick={() => this.getClientById(client.id)} size="small" style={{ marginRight: 10 }} color="secondary" aria-label="edit">
                            <EditIcon />
                        </Fab>
                        <Fab title={this.props.t("delete")} onClick={() => this.setState({ clientToDelete: client, dialogOpen: true })} size="small" style={{ marginRight: 10 }} color="inherit" aria-label="delete">
                            <DeleteIcon />
                        </Fab>
                        <Fab title={this.props.t("add_new_user")} onClick={() => this.setState({ userModalOpen: true, clientId: client.id })} size="small" style={{ marginRight: 10 }} color="primary" aria-label="create_new_user">
                            <PersonAddIcon />
                        </Fab>
                    </TableCell>
                </TableRow >
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <CardHeader
                    title={this.props.t("clients")}
                    action={
                        <Button className="gradient-button gradient-button-4" variant="contained" color="secondary" aria-label="edit" onClick={() => this.setState({ clientToEdit: null, isOpen: true })} style={{ top: '4px' }}>
                            {this.props.t("add_new_client")}
                        </Button>
                    } />
                <Card>
                    <CardContent>
                        <TableContainer component={Paper}>
                            <Table aria-label="simple table" size="small" style={{ tableLayout: 'fixed' }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell component="th" scope="row" width="5%"></TableCell>
                                        <TableCell component="th" scope="row" width="15%">{this.props.t("name")}</TableCell>
                                        <TableCell component="th" scope="row" width="20%">{this.props.t("address")}</TableCell>
                                        <TableCell component="th" scope="row" width="10%">{this.props.t("city")}</TableCell>
                                        <TableCell component="th" scope="row" width="10%">{this.props.t("postal_code")}</TableCell>
                                        <TableCell component="th" scope="row" width="10%">{this.props.t("country")}</TableCell>
                                        <TableCell component="th" scope="row" width="10%">{this.props.t("reporting_currency")}</TableCell>
                                        <TableCell component="th" scope="row" width="5%">{this.props.t("active")}</TableCell>
                                        <TableCell component="th" scope="row" width="15%"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {clientsList}
                                    {recordsNotFound}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            count={this.state.totalElements}
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            page={this.state.activePage}
                            onPageChange={this.handleChangePage}
                            rowsPerPage={this.state.rowsPerPage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            backIconButtonText={this.props.t("previous_page")}
                            labelRowsPerPage={this.props.t("rows_per_page")}
                            nextIconButtonText={this.props.t("next_page")}
                        />
                    </CardContent>
                </Card>
            </Grid>
            <CreateOrUpdateClient
                isOpen={isOpen}
                onClose={this.closeDialog}
                reportingCurrency={this.state.reportingCurrency}
                clientToEdit={this.state.clientToEdit ? this.state.clientToEdit : null}
                getClients={() => this.getClients(0)}
            />
            <CreateOrUpdateUser
                userModalOpen={userModalOpen}
                onClose={this.closeDialogUserModal}
                roleList={this.state.roles}
                clientId={clientId}
            />
            {
                clientToDelete && <ConfirmationDialog
                    isOpen={dialogOpen}
                    title={this.props.t("delete_client")}
                    message={this.props.t("delete_dialog_message", { name: clientToDelete.name })}
                    onClose={() => this.setState({ dialogOpen: false })}
                    onConfirm={() => this.setState({ dialogOpen: false }, () => this.deleteClient())}
                    closeButtonTitle={this.props.t("close")}
                    confirmButtonTitle={this.props.t("delete")}
                />
            }
        </Grid >
    }
}

export default withSnackbar(withTranslation()(Clients))